/**
 * [CS-6079] helper function to extract the encoded_id from a potentially duplicated ad
 */
export const extractEncodedId = (video) => {
    return video?.badge === 'ad'
        ? video.encoded_id.split('--')[0]
        : video?.encoded_id;
};
